import { c, IllustrationFrame, sc, type IllustrationProps } from './Illustration';

/** Calendar empty state. A calendar page with a party hat on one date. */
export function CalendarPop(props: IllustrationProps) {
  return (
    <IllustrationFrame {...props}>
      <ellipse cx="80" cy="142" rx="48" ry="6" style={{ fill: sc('border.default') }} />
      <rect
        x="30"
        y="34"
        width="100"
        height="100"
        rx="14"
        style={{ fill: sc('bg.surface'), stroke: sc('border.strong'), strokeWidth: 3 }}
      />
      <path
        d="M30 48a14 14 0 0 1 14-14h72a14 14 0 0 1 14 14v10H30z"
        style={{ fill: c('blue.500') }}
      />
      <rect x="52" y="24" width="8" height="20" rx="4" style={{ fill: c('neutral.700') }} />
      <rect x="100" y="24" width="8" height="20" rx="4" style={{ fill: c('neutral.700') }} />
      {[0, 1, 2, 3].map((col) =>
        [0, 1, 2].map((row) => (
          <rect
            key={`${col}-${row}`}
            x={42 + col * 20}
            y={68 + row * 20}
            width="12"
            height="12"
            rx="3"
            style={{ fill: col === 2 && row === 1 ? c('berry.400') : sc('border.default') }}
          />
        )),
      )}
      <path d="M88 86l8-22 8 22z" style={{ fill: c('gold.400') }} />
      <circle cx="96" cy="62" r="3" style={{ fill: c('berry.300') }} />
      <circle cx="126" cy="26" r="4" style={{ fill: c('gold.400') }} />
      <circle cx="22" cy="60" r="3" style={{ fill: c('mint.300') }} />
    </IllustrationFrame>
  );
}
